<template>
  <div>
    <div class="top">
      <div><img src="@/assets/personal/work/back.png" alt="" class="top-left-img" @click="back"></div>

      <div> 
        <img src="@/assets/work/qingjia.png" alt="" class="top-midlle-img">
      </div>
      <div class="top-midlle-span">请假</div>
     
    </div>
    <div class="middle">
      <el-form :model="formData" :rules="rules" 
          ref="form"
        label-width="100px" 
        >   


        <el-form-item label="职位选择" prop="job_id">
          <el-select
              v-model="formData.job_id" placeholder="全部"
                clearable
                filterable
                @change="selectJob"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>


        <el-form-item label="请假类型" prop="type">
          <el-select v-model="formData.type" placeholder="请选择请假类型">
            <!--1病假2婚假3事假-->
            <el-option label="病假" :value="1"></el-option>
            <el-option label="婚假" :value="2"></el-option>
            <el-option label="事假" :value="3"></el-option>
            <el-option label="丧假" :value="4"></el-option>

          </el-select>   
        </el-form-item>
        
        <el-form-item label="请假时间" required>
            <el-form-item prop="min_time">
              <el-date-picker type="datetime" placeholder="开始时间"  v-model="formData.min_time" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item prop="max_time">
              <el-date-picker type="datetime" placeholder="结束时间"  v-model="formData.max_time" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
        </el-form-item>
        

       <el-row  v-for="(item, index) in formData.HasGroup" :key="item.group_id">
            <el-form-item  :label="item.title" :prop="'HasGroup.' + index + '.value'"  :rules="rules.comp">

                <!--文本-->
                <el-input v-if="item.type==1" v-model="item.value" :placeholder="item.shuomin"></el-input>
                <!--多行文本-->
                <el-input v-if="item.type==2" type="textarea" v-model="item.value" :placeholder="item.shuomin"></el-input>

                <!--数字-->
                <el-input-number v-if="item.type==3" v-model="item.value" :label="item.shuomin"></el-input-number>

                 <!--日期-->
                 <el-date-picker
                    v-if="item.type==4"
                    v-model="item.value"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
                  <!--日期时间-->
                  <el-date-picker
                      v-if="item.type==5"
                      v-model="item.value"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期时间">
                    </el-date-picker>


            </el-form-item>
        
        </el-row>
        <el-form-item label="事由" prop="mark"  >
          <el-input  type="textarea" v-model="formData.mark" placeholder="请填写事由">
          </el-input>
        </el-form-item>

        <el-form-item label="汇报人" prop="director_ids"  >
         <el-select v-model="formData.director_ids" placeholder="请选择" multiple clearable>
           <el-option
            v-for="item in formData.directors"
              :key="item.user_app_id"
              :label="item.nickname"
              :value="item.user_app_id">
          </el-option>
         </el-select>
       </el-form-item>


       <el-form-item label="抄送人" prop="copy_ids" >
         <el-select v-model="formData.copy_ids" placeholder="请选择" multiple clearable>
          
           <el-option
            v-for="item in formData.copys"
              :key="item.user_app_id"
              :label="item.nickname"
              :value="item.user_app_id">
          </el-option>
         </el-select>
       </el-form-item>

       <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="back">取消</el-button>
       </el-form-item>

        
      </el-form>
    </div>
  </div>
</template>

<script>
import { jobCheckList} from "@/api/personal/work/job/index";
import { leaveInfo,leaveUserAdd} from "@/api/personal/work/approval/index";


export default {
  data() {
    return {
      jobDataList:[],
      link:"1",
      formData: {
        job_id: '',
        project_id:'',
        director_ids: [],
        copy_ids: [],

        link: 1,//1,类型，

        type: "",//请假类型，1病假2婚假3事假4丧假5出差6加班
        min_time: null,//请假开始时间
        max_time:null,//请假结束时间

        money:"",//报销金额
        detaileds:"",//报销详细流水
        refund_time:"",//报销时间


        mark: '',
        group_content: {},// "group_content":{"价格'": "2","'商品'": "1"},
        
        directors:[],
        copys:[],//   

        HasGroup:[]
      },

      setInfo:{

      },
      rules: {
       
          job_id: [
                {required: true, message: '请选择职位', trigger: 'change'}
            ],
          type: [
              {required: true, message: '请选择请假类型', trigger: 'change'}
          ],
          min_time: [
              {required: true, message: '请选择请假开始时间', trigger: 'blur'}
          ],
          max_time: [
              {required: true, message: '请选择请假结束时间', trigger: 'blur'}
          ],
          director_ids: [
              {required: true, message: '请选择汇报人', trigger: 'blur'}
          ],
          comp: [
              {required: true, message: '请填写数据', trigger: 'blur'}
          ],
          
      }
    };
  },
  mounted(){
      //this.link=this.$route.query.link;
     // this.formData.link = this.$route.query.link*1;
      this.initJobList();

  },
  methods: {

      //职位列表
    initJobList(){
      var that = this;
      jobCheckList({}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },

    selectJob(e){
      console.log(e)
      this.formData.job_id=e;
      this.initLeaveInfo();


    },


    initLeaveInfo(){
        var that=this;
        leaveInfo({job_id:that.formData.job_id,link:that.link}).then((response) => {
          console.log(response);
          if(response.code==200){
            var data=response.data;

            if(Object.keys(data).length>0){
              that.formData=data;

            }else{
              that.formData.director_ids=[];
              that.formData.copy_ids=[];
              that.formData.directors=[];
              that.formData.copys=[];
            }
            
           
          }else{
            this.$message({
              message: response.msg?response.msg:"获取信息失败",
            });
          }
        });
    },

    onSubmit(){
      var that=this;

      var params={
        job_id:this.formData.job_id,
        director_ids:this.formData.director_ids,
        copy_ids:this.formData.copy_ids,
        link:that.link,
        type:this.formData.type,
        min_time:this.formData.min_time,
        max_time:this.formData.max_time,
        mark:this.formData.mark,
        group_content:[]

      }

      //arr.join(','); // 把数组项拼接成字符串，以逗号,分隔

     

      params.group_content=this.formData.HasGroup;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            leaveUserAdd(params).then((response) => {
                    console.log(response);
                    if(response.code==200){
                      this.$message({
                        message: "提交成功",
                        type: 'success'
                      });
                      this.$router.push({ name: "personal-work-approval-leave-info" });

                    }else{
                      this.$message({
                        message: response.msg?response.msg:"提交失败",
                      });
                    }
                });
            } 
        });
    },


    back(){
      this.$router.go(-1);
    }
    
   
  }
}
</script>

<style lang="scss" scoped>
.top{
  width: 950px;
  height: 31px;
  display: flex;
}
.top-left-img{
  margin-top: 8px;
  width: 25px;
  height: 25px;
}
.top-midlle-img{
  width: 40px;
height: 40px;
}
.top-midlle-span{
  margin-left: 20px;
  margin-top: 8px;
height: 16px;
font-size: 16px;
color: #181818;
font-weight: bold;
}
.top-right{
  margin-top: 2px;
 margin-left: 740px;
}
 
.middle{
  width: 840px;
  height: 565px;
  margin-top: 40px;
  flex-direction:column;
}
</style>